module.exports = __webpack_public_path__ + "static/media/12-4.4305ac5d.mp3";